import { useState } from 'react';
import { Tooltip, theme as antdTheme } from 'antd';
import { BgColorsOutlined } from '@ant-design/icons';
import { AppearanceDrawer } from '@/app/appearance-drawer';

/**
 * Header brush icon — opens the appearance drawer (Phase 2). The drawer holds
 * both the theme grid and the density toggle; the icon itself is just the
 * trigger so it can also live in the mobile nav drawer (`sider-mobile-extras`).
 */
export function ThemePicker() {
  const { token } = antdTheme.useToken();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip title="Appearance">
        <span
          role="button"
          aria-label="Open appearance settings"
          onClick={() => setOpen(true)}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 36,
            height: 36,
            borderRadius: 8,
            cursor: 'pointer',
            color: token.colorText,
          }}
        >
          <BgColorsOutlined style={{ fontSize: 16 }} />
        </span>
      </Tooltip>
      <AppearanceDrawer open={open} onClose={() => setOpen(false)} />
    </>
  );
}
